import {
  isObservable,
  isObservableArray,
  isObservableMap,
  isObservableSet,
  isBoxedObservable,
  isComputed,
  ownKeys,
  type IComputedValue,
} from 'mobx';

/** Error recovery dependency reads, following the observable data that toJS
 * normally visits without constructing DTOs or invoking their getters. A bad
 * extension field must not prevent tracking unrelated fields or later chips. */
export function observeSnapshotInput(value: unknown, seen = new Set<object>()): void {
  if (!value || typeof value !== 'object' || !isObservable(value) || seen.has(value))
    return;
  seen.add(value);
  if (isBoxedObservable(value) || isComputed(value)) {
    observeSnapshotInput((value as IComputedValue<unknown>).get(), seen);
  } else if (isObservableArray(value)) {
    for (let i = 0; i < value.length; i++) {
      try {
        observeSnapshotInput(value[i], seen);
      } catch {
        /* Continue tracking independent array items. */
      }
    }
  } else if (isObservableMap(value) || isObservableSet(value)) {
    for (const child of value.values()) {
      try {
        observeSnapshotInput(child, seen);
      } catch {
        /* Continue tracking independent collection items. */
      }
    }
  } else {
    for (const key of ownKeys(value))
      if (Object.prototype.propertyIsEnumerable.call(value, key)) {
        try {
          observeSnapshotInput((value as Record<PropertyKey, unknown>)[key], seen);
        } catch {
          /* Continue tracking independent observable fields. */
        }
      }
  }
}
